import { render, staticRenderFns } from "./WaybillListView.vue?vue&type=template&id=712c8d17&"
import script from "./WaybillListView.vue?vue&type=script&lang=js&"
export * from "./WaybillListView.vue?vue&type=script&lang=js&"
import style0 from "./WaybillListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports